import { Component, ojs, app } from "modular-openscriptjs";
import { dom } from "../../fotastart";
import { _UNIQUE_ID_ } from "../../declarations";

const h = app("h");

export default class InfiniteScroll extends Component {
	observers = {};

	/**
	 *
	 * @param {object} config
	 * @returns
	 */
	render(config, ...args) {
		let holder = config.child;
		let callback = config.callback;
		let managed = config.managed ?? false;

		let id = `${holder.getAttribute("uuid")}-${_UNIQUE_ID_}`;

		if (!id) {
			throw Error(
				`The element passed to an InfiniteScroll must has a uuid attribute`
			);
		}

		let marker = h.div({
			class: "mb-5",
			ifs_id: `${id}`,
			ifs_marker: true,
		});

		this.createObserver(id, marker, callback);

		if (managed) {
			holder.append(marker);
			return holder;
		}

		return [holder, marker];
	}

	createObserver(id, marker, callback) {
		let options = {
			root: null,
			rootMargin: "0px",
			threshold: 0.0,
		};

		let observer = new IntersectionObserver((entries, observer) => {
			return callback(entries, observer, marker);
		}, options);

		this.cleanUp();
		this.observers[id] = observer;
		observer.observe(marker);
	}

	cleanUp() {
		for (let k in this.observers) {
			if (!dom.get(`[ifs_id="${k}"]`)) {
				delete this.observers[k];
			}
		}
	}
}
